<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="add-article-reference-modal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <form @submit.prevent="submit">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">
                &times;
              </span>
            </button>

            <h4 class="modal-title">
              Add Mentioned Company
            </h4>
          </div>

          <div class="modal-body">
            <TypeaheadFormGroup
                v-model="data.portal_company_id"
                endpoint="/api/v2/portal-companies"
                :params="{'filter[portal_id]': portal.id}"
                :token="shared.token"
                path="data.data"
                placeholder="Search..."
                :result-label-property="row => row.attributes.name || row.attributes.company_name"
            />
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>

            <button type="submit" class="btn btn-black">
              <i class="fa fa-save"></i> Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import store from '@/store'
import Errors from '@/mixins/Errors'
import TypeaheadFormGroup from '@/vendor/forms/FormGroups/Block/Typeahead'

export default {
  components: {TypeaheadFormGroup},

  mixins: [Errors],

  props: {
    selected: {
      type: Array
    },

    portal: {
      type: Object
    }
  },

  data() {
    return {
      data: {},

      shared: store,
    }
  },

  mounted() {
    this.listenForClose()
  },

  methods: {
    listenForClose() {
      $(this.$el).on('hidden.bs.modal', this.reset)
    },

    submit() {
      if (!this.selected.length) {
        notify.error('No companies selected')
      }

      if (!this.data.portal_company_id) {
        this.errors = {
          portal_company_id: ['The company field is required.']
        }

        return
      }

      Promise
          .all(this.selected.map(contentArticle => http.put('/api/v2/content-articles/' + contentArticle.id, {
            ...contentArticle.attributes,
            content_article_references: contentArticle.attributes.content_article_references.concat([this.data])
          })))
          .then(responses => {
            notify.success('The mentioned company was added')

            responses.map(response => this.$emit('updated', response.data.data))

            $(this.$el).modal('hide')
          })
    },

    reset() {
      this.errors = {}

      this.data = {}
    }
  }
}
</script>
